import theme from '../theme';

const preleadColor = (status: string) => {
  const preleadColors: {[key: string]: string} = theme.status.prelead;
  return preleadColors[status];
};

export default preleadColor;
